export const APP_CONSTANTS = {
    SHAREPOINT_URL: 'https://quantumep.sharepoint.com/sites/MasterDataManagement/Lists/',
    SHAREPOINT_VIEW_ID: {
        PortfolioCompany: "48e4796d-998c-47f7-8f2c-4b3f60d82751",
        PortfolioCompanyQuiltDev: "50de5353-5a0c-4188-a0a6-e3c731a4c357",
        PortfolioCompanyContact: "3a9623ef-c0f7-4e55-8adb-6e488e7690de"
    }
}
